import React from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { MEDIA_URL } from '../../../../constants/api';
import EmptyAvatar from '../../../../assets/images/emptyAvatar.png';
import Text from '../../../../components/Text/Text';
import routes from '../../../../router/routes';
import Badge from '../../../../components/Badge/Badge';
import ButtonTypes from '../../../../constants/buttonTypes';
import Card from '../../../../components/Card/Card';

const cardClassName = 'w-[350px]';
const avatarClassName = 'w-[100px] h-[100px] rounded-full mb-[22px]';
const nameClassName = 'font-medium text-[16px] mb-[10px]';
const badgeClassName = 'text-[13px] capitalize font-medium mb-[30px] cursor-pointer';
const detailsHeaderClassName = 'border-b border-[#eff2f5] dark:border-[#1b263b] mb-[16px]';
const detailsTextClassName = 'font-medium text-[16px] py-[10px]';
const itemDetailsClassName = 'mb-[16px]';
const capitalizeClassName = 'capitalize';
const linkClassName = 'no-underline hover:text-primary';

const UserCard = ({ user }) => {
  const navigate = useNavigate();
  const {
    id,
    avatar,
    last_name: lastName,
    name,
    email,
    login,
    last_login: lastLogin,
    created_at: createDate,
    role: { name: roleName, id: roleId } = {}
  } = user || {};
  return (
    <Card
      styleContainer={cardClassName}
      showHeader={false}
    >
      <div className="flex flex-col justify-center items-center">
        <img src={avatar ? `${MEDIA_URL}/${avatar}` : EmptyAvatar} alt="user avatar img" className={avatarClassName} />
        <Text text={`${name} ${lastName || ''}`} textStyle={nameClassName} />
        <div
          className={badgeClassName}
          onClick={() => navigate(`${routes.ROLES}/${roleId}`)}
          role="presentation"
        >
          <Badge text={roleName} type={ButtonTypes.LIGHT_PRIMARY} />
        </div>
      </div>
      <div className={detailsHeaderClassName}>
        <Text text="Details" textStyle={detailsTextClassName} />
      </div>
      <div className={itemDetailsClassName}>
        <Text text="Account ID" />
        <Text text={`ID-${id}`} muted />
      </div>
      <div className={itemDetailsClassName}>
        <Text text="Login" />
        <Text text={login} muted textStyle={capitalizeClassName} />
      </div>
      <div className={itemDetailsClassName}>
        <Text text="Email" />
        <a href={`mailto:${email}`} className={linkClassName}>
          <Text text={email} muted textStyle={linkClassName} />
        </a>
      </div>
      <div className={itemDetailsClassName}>
        <Text text="Last Login" />
        <Text
          text={lastLogin && DateTime.fromISO(lastLogin).setLocale('en').toFormat('ff')}
          muted
          textStyle={capitalizeClassName}
        />
      </div>
      <div className={itemDetailsClassName}>
        <Text text="Joined Date" />
        <Text
          text={createDate && DateTime.fromISO(createDate).setLocale('en').toFormat('DD')}
          muted
          textStyle={capitalizeClassName}
        />
      </div>
    </Card>
  );
};

UserCard.propTypes = {
  user: PropTypes.shape({})
};

UserCard.defaultProps = {
  user: {}
};

export default UserCard;
